import { useState } from "react";

import { Box } from "@/components/layout/flexbox";
import { ScenariosList } from "@/components/pages_logged_in/roleplays/scenarios/ScenariosList";
import { Container } from "@/components/pieces/bootstrap";
import { Tabs } from "@/components/pieces/Tabs";
import { QueryScenariosStatus } from "@/graphql";
import { Tab } from "@/types/tabs";

import { RoleplaysList } from "./RoleplaysList";

const ROLEPLAY_TABS: Tab[] = [
  {
    key: "collections",
    label: "Collections",
  },
  {
    key: "scenarios",
    label: "Scenarios",
  },
];

export function AllRoleplaySection({ pageLoading = false }) {
  const [selectedTab, setSelectedTab] = useState(ROLEPLAY_TABS[0]);

  return (
    <Container>
      <Box fontSize={24} fontWeight={600} mb={3}>
        All Roleplays
      </Box>
      <Tabs
        tabs={ROLEPLAY_TABS}
        tab={selectedTab}
        onTabChange={(tab) => setSelectedTab(tab)}
        style={{
          borderTop: "none",
          boxShadow: "0px 1px 0px 0px #E7EBF7",
        }}
        backgroundColor="transparent"
      />
      {selectedTab.key === "collections" && (
        <RoleplaysList includeOwnerData={true} isLoadingPage={pageLoading} />
      )}
      {selectedTab.key === "scenarios" && (
        <ScenariosList
          pageType="all"
          statusFilter={QueryScenariosStatus.All}
          scopeFilter="All"
          showShortDesc={true}
          showPlayButton={false}
          showScope={true}
          showAction={true}
          allowAdd={true}
        />
      )}
    </Container>
  );
}
